import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * `twMerge` necesita conocer nuestras escalas propias para resolver bien los
 * conflictos: sin esto, `h-control-md` y `h-10` convivirían en la misma clase y
 * ganaría el orden del CSS en vez del orden de las props.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['2xs', 'xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl'] },
      ],
      h: [{ h: ['control-xs', 'control-sm', 'control-md', 'control-lg', 'topbar', 'tabbar', 'table-row'] }],
      w: [{ w: ['sidebar', 'sidebar-collapsed'] }],
      rounded: [{ rounded: ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', 'full', 'none'] }],
      shadow: [{ shadow: ['none', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', 'focus'] }],
    },
  },
});

/** Une clases condicionales y resuelve conflictos de Tailwind. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
